import { useEnrichedAuth } from '@/hooks/useEnrichedAuth';

/**
 * Compatibility shim for the existing PublicLayout consumer.
 *
 * Previously this hook stored a raw access token in <c>localStorage</c> under
 * its own key — that pre-dates the SDK's <c>AuthProvider</c>. The Resource
 * Centre is now wired to the same SDK auth pipeline as ccms_v2 / ccms_vendors,
 * so this hook just forwards <c>isAuthenticated</c> + <c>signOut</c> from
 * <c>useEnrichedAuth</c> to keep the existing call-sites working.
 */
export function useOptionalAuth() {
  const auth = useEnrichedAuth();
  return {
    isAuthenticated: auth.isAuthenticated,
    /** Kept for backwards compatibility — token is now managed by the SDK. */
    token: null as string | null,
    /** Stub — the SDK manages tokens internally now. */
    setAccessToken: (_next: string | null) => {
      // no-op; left in place to avoid breaking older imports
    },
    signOut: () => auth.logout(),
  };
}
